import { render, staticRenderFns } from "./listWebzine.vue?vue&type=template&id=71f5601a&scoped=true"
import script from "./listWebzine.vue?vue&type=script&lang=js"
export * from "./listWebzine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5601a",
  null
  
)

export default component.exports